module.exports = __webpack_public_path__ + "img/Illustration - Document@3x.394bc8d7.png";